<template>
  <div>
    <b-modal
      ref="modal-operations-travel-order"
      :title="getTitle"
      title-tag="h4"
      modal-class="modal-primary"
      size="xl"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      @hidden="$emit('hideModal')"
    >
      <b-row>
        <b-col md="12" lg="7" xl="8" class="pb-1">
          <b-card
            :bg-variant="isDarkSkin ? 'black' : 'white'"
            class="mb-1 h-100"
          >
            <ValidationObserver ref="ref-validation-travel">
              <b-row>
                <!-- Serie -->
                <b-col md="12" lg="6" xl="4">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="serie"
                  >
                    <b-form-group
                      label="Serie"
                      label-for="serie"
                      :state="errors[0] ? false : null"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="serie"
                        v-model="form.serie"
                        v-mask="'####'"
                        trim
                        :state="errors[0] ? false : null"
                        :disabled="true"
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Number -->
                <b-col md="12" lg="6" xl="4">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="number"
                  >
                    <b-form-group
                      :label="$t('Number')"
                      label-for="number"
                      :state="errors[0] ? false : null"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="number"
                        v-model="form.number"
                        v-mask="'########'"
                        trim
                        :state="errors[0] ? false : null"
                        :disabled="true"
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Travel date -->
                <b-col md="12" lg="6" xl="4">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="travel_date"
                  >
                    <b-form-group
                      :label="$t('Date')"
                      label-for="travel_date"
                      :state="errors[0] ? false : null"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <kendo-datepicker
                        v-if="finishedLoading"
                        class="w-100 rounded form-control-kendo"
                        :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                        :min="minDate"
                        :max="maxDate"
                        v-model="form.travel_date"
                        :format="'dd/MM/yyyy'"
                        name="created_date"
                        id="travel_date"
                      ></kendo-datepicker>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Travel date -->
                <b-col md="12" lg="6" xl="4">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="modality"
                  >
                    <b-form-group
                      :label="$t('Modality')"
                      label-for="modality"
                      :state="errors[0] ? false : null"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <v-select
                        v-if="finishedLoading"
                        id="modality"
                        v-model="form.modality"
                        :options="modalityOptions"
                        append-to-body
                        :clearable="false"
                        :calculate-position="positionDropdown"
                        :placeholder="`${$t('Select a modality')}...`"
                        :reduce="(l) => l.id"
                        label="name"
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Driver -->
                <b-col md="12" lg="12" xl="8">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="driver"
                  >
                    <b-form-group
                      :label="$t('Driver')"
                      label-for="driver"
                      :state="errors[0] ? false : null"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <v-select
                        v-if="finishedLoading"
                        id="driver"
                        v-model="form.driver_id"
                        :options="driverOptions"
                        append-to-body
                        :clearable="false"
                        :calculate-position="positionDropdown"
                        :placeholder="`${$t('Select a driver')}...`"
                        :reduce="(l) => l.id"
                        label="name"
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Vehicles -->
                <b-col md="6" lg="6">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="vehicle_id"
                  >
                    <b-form-group
                      :label="$t('Vehicle')"
                      label-for="vehicle_id"
                      :state="errors[0] ? false : null"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <v-select
                        v-if="finishedLoading"
                        id="driver"
                        v-model="form.vehicle_id"
                        :options="vehicleOptions"
                        append-to-body
                        :clearable="false"
                        :calculate-position="positionDropdown"
                        :placeholder="`${$t('Select a vehicle')}...`"
                        :reduce="(l) => l.id"
                        label="name"
                        @input="getDataVehicleSelected"
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Trailer -->
                <b-col md="6" lg="6">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="trailer_id"
                  >
                    <b-form-group
                      :label="$t('Trailer')"
                      label-for="trailer_id"
                      :state="errors[0] ? false : null"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <v-select
                        v-if="finishedLoading"
                        id="trailer_id"
                        v-model="form.trailer_id"
                        :options="trailerOptions"
                        append-to-body
                        :clearable="false"
                        :calculate-position="positionDropdown"
                        :placeholder="`${$t('Select a trailer')}...`"
                        :reduce="(l) => l.id"
                        label="name"
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </ValidationObserver>
          </b-card>
        </b-col>

        <b-col md="12" lg="5" xl="4" class="pb-1">
          <b-card
            :bg-variant="isDarkSkin ? 'black' : 'white'"
            title-tag="h5"
            class="mb-1 h-100"
          >
            <b-card-title>
              <h4>{{ $t("Vehicle info") }}</h4>
            </b-card-title>

            <div class="d-flex flex-column">
              <div class="d-flex justify-content-between">
                <span class="">
                  <tabler-icon icon="LoaderIcon" class="text-info" />
                  {{ $t("Current km") }}
                </span>
                <span v-if="form.vehicle_id" class="text-left ml-1">
                  : {{ vehicleInfo.current_km }}
                </span>
                <span v-else class="text-left ml-1">
                  :
                  <b-badge variant="light-warning">
                    {{ $t("Not found") }}
                  </b-badge>
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="">
                  <tabler-icon icon="LoaderIcon" class="text-info" />
                  {{ $t("Load capacity type") }}
                </span>
                <span v-if="form.vehicle_id" class="text-left ml-1">
                  : {{ vehicleInfo.load_capacity_type }}
                </span>
                <span v-else class="text-left ml-1">
                  :
                  <b-badge variant="light-warning">
                    {{ $t("Not found") }}
                  </b-badge>
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="">
                  <tabler-icon icon="LoaderIcon" class="text-info" />
                  {{ $t("Load capacity") }}
                </span>
                <span v-if="form.vehicle_id" class="text-left ml-1">
                  : {{ vehicleInfo.load_capacity }}
                </span>
                <span v-else class="text-left ml-1">
                  :
                  <b-badge variant="light-warning">
                    {{ $t("Not found") }}
                  </b-badge>
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="">
                  <tabler-icon icon="LoaderIcon" class="text-info" />
                  {{ $t("Axies number") }}
                </span>
                <span v-if="form.vehicle_id" class="text-left ml-1">
                  : {{ vehicleInfo.axies_number }}
                </span>
                <span v-else class="text-left ml-1">
                  :
                  <b-badge variant="light-warning">
                    {{ $t("Not found") }}
                  </b-badge>
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="">
                  <tabler-icon icon="LoaderIcon" class="text-info" />
                  {{ $t("Dry weight") }}
                </span>
                <span v-if="form.vehicle_id" class="text-left ml-1">
                  : {{ vehicleInfo.dry_weight }}
                </span>
                <span v-else class="text-left ml-1">
                  :
                  <b-badge variant="light-warning">
                    {{ $t("Not found") }}
                  </b-badge>
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="">
                  <tabler-icon icon="LoaderIcon" class="text-info" />
                  {{ $t("Gross weight") }}
                </span>
                <span v-if="form.vehicle_id" class="text-left ml-1">
                  : {{ vehicleInfo.gross_weight }}
                </span>
                <span v-else class="text-left ml-1">
                  :
                  <b-badge variant="light-warning">
                    {{ $t("Not found") }}
                  </b-badge>
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="">
                  <tabler-icon icon="LoaderIcon" class="text-info" />
                  {{ $t("Useful load") }}
                </span>
                <span v-if="form.vehicle_id" class="text-left ml-1">
                  : {{ vehicleInfo.useful_load }}
                </span>
                <span v-else class="text-left ml-1">
                  :
                  <b-badge variant="light-warning">
                    {{ $t("Not found") }}
                  </b-badge>
                </span>
              </div>
            </div>
          </b-card>
        </b-col>

        <b-col md="12" lg="7" xl="8" class="pb-1">
          <b-card
            :bg-variant="isDarkSkin ? 'black' : 'white'"
            title-tag="h5"
            class="mb-1 h-100"
          >
            <b-card-title>
              <div class="d-flex justify-content-between">
                <h4>{{ $t("Service Orders") }}</h4>
                <tabler-icon
                  v-b-tooltip.hover.v-primary
                  :title="$t('Add services')"
                  icon="PlusIcon"
                  class="text-primary cursor-pointer"
                  size="25"
                  @click="addServiceOrders"
                />
              </div>
            </b-card-title>
            <b-table-simple
              hover
              small
              responsive
              class="font-small-3"
              sticky-header="20vh"
              show-empty
              table-class="text-nowrap"
            >
              <b-thead>
                <b-tr>
                  <b-th> {{ $t("Service") }} </b-th>
                  <b-th class="text-center"> Qty O.D. </b-th>
                  <b-th class="text-center"> {{ $t("Quantity") }} </b-th>
                  <b-th class="text-center"> {{ $t("Volume") }} </b-th>
                  <b-th class="text-center"> {{ $t("Weight") }} </b-th>
                  <b-th class="text-center"> {{ $t("Actions") }} </b-th>
                </b-tr>
              </b-thead>

              <b-tbody>
                <template v-for="(service, key) in form.service_orders">
                  <b-tr :key="key">
                    <b-td>
                      <div class="d-flex flex-column">
                        <span class="text-primary">
                          {{ service.service_order }}
                        </span>
                        <span>
                          <tabler-icon icon="UserIcon" class="text-warning" />
                          <span v-if="service.business_name != null">{{
                            service.business_name
                          }}</span>
                          <span v-else> {{ $t("Client not found") }} </span>
                        </span>
                      </div>
                    </b-td>
                    <b-td class="text-info text-center">
                      <b-badge variant="light-info">
                        {{ service.qty_documents }}
                      </b-badge>
                    </b-td>
                    <b-td class="text-info text-center">
                      {{ service.quantity }}
                    </b-td>
                    <b-td class="text-primary text-center">
                      {{ service.volume.toFixed(3) }}
                    </b-td>
                    <b-td class="text-warning text-center">
                      {{ service.weight.toFixed(3) }}
                    </b-td>
                    <b-td class="text-warning text-center">
                      <feather-icon
                        v-if="!service.is_delete"
                        icon="TrashIcon"
                        class="text-danger"
                        v-b-tooltip.hover.v-danger
                        :title="$t('Remove service')"
                        @click="deleteService(service)"
                      />
                      <feather-icon
                        v-else
                        icon="RotateCcwIcon"
                        class="text-success cursor-pointer"
                        v-b-tooltip.hover.v-success
                        :title="$t('Reverse changes')"
                        @click="service.is_delete = false"
                      />
                    </b-td>
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
          </b-card>
        </b-col>

        <b-col md="12" lg="5" xl="4" class="pb-1">
          <b-card
            :bg-variant="isDarkSkin ? 'black' : 'white'"
            title-tag="h5"
            class="mb-1 h-100"
          >
            <b-card-title>
              <div class="d-flex">
                <h4>{{ $t("Tolls") }}</h4>
                <span v-if="form.count_tolls > 0" style="margin-left: 5px">
                  ({{ form.count_tolls }})
                </span>
                <span v-if="form.count_tolls > 0" class="ml-1">
                  {{ form.origin }} - {{ form.destination }}
                </span>
              </div>
            </b-card-title>

            <b-table-simple
              hover
              small
              responsive
              class="font-small-3"
              sticky-header="20vh"
              show-empty
              table-class="text-nowrap"
            >
              <b-thead>
                <b-tr>
                  <b-th> {{ $t("Name") }} </b-th>
                  <b-th class=""> {{ $t("Type") }} </b-th>
                  <b-th class="text-center"> {{ $t("Amount") }} </b-th>
                  <b-th class="text-center"> {{ $t("Axies") }} </b-th>
                  <b-th class="text-center"> {{ $t("Total") }} </b-th>
                </b-tr>
              </b-thead>

              <b-tbody>
                <template v-for="(toll, key) in form.tolls">
                  <b-tr :key="key">
                    <b-td>
                      <div class="d-flex">
                        <tabler-icon
                          icon="GasStationIcon"
                          class="text-primary"
                          size="18"
                        />
                        <span class="text-primary" style="margin-left: 5px">
                          {{ toll.toll }}
                        </span>
                      </div>
                    </b-td>
                    <b-td>
                      <div class="d-flex justify-align-center">
                        <tabler-icon
                          v-if="toll.type == 'ELECTRONIC'"
                          icon="CreditCardIcon"
                          class="text-primary"
                          size="18"
                          v-b-tooltip.hover.v-primary
                          :title="$t(toll.type)"
                        />
                        <tabler-icon
                          v-else
                          icon="CashIcon"
                          class="text-success"
                          size="18"
                          v-b-tooltip.hover.v-success
                          :title="$t(toll.type)"
                        />
                        <!-- <span style="margin-left: 5px">
                          {{ $t(toll.type) }}
                        </span> -->
                      </div>
                    </b-td>
                    <b-td>
                      <div class="d-flex justify-content-center">
                        <span class="text-success">
                          S/. {{ toll.amount | currency }}
                        </span>
                      </div>
                    </b-td>
                    <b-td>
                      <div class="d-flex justify-content-center">
                        <span class="text-success">
                          {{ vehicleInfo.axies_number }}
                        </span>
                      </div>
                    </b-td>
                    <b-td>
                      <div class="d-flex justify-content-center">
                        <span class="text-success">
                          S/.
                          {{
                            (toll.amount * vehicleInfo.axies_number) | currency
                          }}
                        </span>
                      </div>
                    </b-td>
                  </b-tr>
                </template>
              </b-tbody>
              <b-tfoot>
                <b-tr
                  class="sticky-data"
                  :class="
                    isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'
                  "
                >
                  <b-td colspan="3"></b-td>
                  <b-td>Total: </b-td>
                  <b-td class="text-center text-primary">S/ 23343</b-td>
                </b-tr>
              </b-tfoot>
            </b-table-simple>
          </b-card>
        </b-col>
      </b-row>

      <b-card :bg-variant="isDarkSkin ? 'black' : 'white'" class="mb-0">
        <div class="d-flex justify-content-between">
          <div>
            {{ $t("Services selected") }} :
            <span class="text-primary"> {{ getTotalSelected }} Items </span>
          </div>
          <div>
            {{ $t("Quantity") }} :
            <span class="text-info"> {{ getTotalQuantitySelected }} </span>
          </div>
          <div>
            {{ $t("Volume") }} :
            <span class="text-primary"> {{ getTotalVolumeSelected }} M3 </span>
          </div>
          <div>
            {{ $t("Weight") }} :
            <span class="text-warning"> {{ getTotalWeightSelected }} </span>
          </div>
        </div>
      </b-card>

      <template #modal-footer>
        <div class="d-flex align-items-center justify-content-end">
          <b-button variant="outline-danger" @click="$emit('hideModal')">
            {{ $t("Cancel") }}
          </b-button>

          <!-- Register -->
          <b-button
            v-if="travelId == null"
            variant="outline-primary"
            class="ml-1"
            @click="registerTravel"
          >
            {{ $t("Register") }}
          </b-button>

          <!-- Edit -->
          <b-button
            v-if="travelId != null"
            variant="outline-warning"
            class="ml-1"
            @click="editTravel"
          >
            {{ $t("Edit") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <ListServicesForTravel
      v-if="addServicesModal"
      :currentServices="currentServices"
      @hideModal="addServicesModal = false"
      @addServices="addServices"
    />
  </div>
</template>

<script>
import modalMixin from "@/mixins/modal";
import moment from "moment";
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";

import ListServicesForTravel from "@/views/operations/views/service-orders/components/modals/ListServicesForTravel.vue";

import vehiclesService from "@/views/settings/views/vehicles/services/vehicles.service";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service";
import TravelOrdersService from "@/views/operations/views/travel-orders/services/travel-orders.service.js";

export default {
  mixins: [modalMixin],
  directives: {
    Ripple,
  },
  components: {
    ListServicesForTravel,
  },
  props: {
    travelId: {
      default: null,
    },
  },
  data() {
    return {
      minDate: new Date(1000, 1, 1),
      maxDate: new Date(2050, 9, 1),
      finishedLoading: false,
      form: {
        serie: null,
        number: null,
        travel_date: null,
        modality: null,
        vehicle_id: null,
        driver_id: null,
        trailer_id: null,
        service_orders: [],
        origin: null,
        destination: null,
        count_tolls: null,
        tolls: [],
      },
      vehicleOptions: [],
      trailerOptions: [],
      driverOptions: [],
      modalityOptions: [
        { id: 1, name: this.$t("One Way") },
        { id: 2, name: this.$t("Round Trip") },
      ],
      currentServices: [],
      addServicesModal: false,
      vehicleInfo: {
        current_km: null,
        load_capacity_type: null,
        load_capacity: null,
        axies_number: 0,
        dry_weight: null,
        gross_weight: null,
        useful_load: null,
      },
    };
  },
  mounted() {
    this.toggleModal("modal-operations-travel-order");
  },
  async created() {
    this.addPreloader();
    this.finishedLoading = false;
    try {
      await Promise.all([
        this.getTravelOrderById(),
        this.getDriversForSelect(),
        this.getVehiclesForSelect("vehicle"),
        this.getVehiclesForSelect("trailer"),
      ]);
    } catch (error) {
      console.log(error);
    } finally {
      this.finishedLoading = true;
      this.removePreloader();
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),

    getTitle() {
      if (this.travelId != null) {
        return this.$t("Edit travel order").toLocaleUpperCase();
      }
      return this.$t("Create travel order").toLocaleUpperCase();
    },

    getTotalSelected() {
      return this.form.service_orders.length;
    },

    getTotalQuantitySelected() {
      let quantity = 0;
      this.form.service_orders.map((service) => {
        quantity += service.quantity;
      });

      return quantity;
    },

    getTotalVolumeSelected() {
      let volume = 0;
      this.form.service_orders.map((service) => {
        volume += service.volume;
      });
      return parseFloat(volume.toFixed(3));
    },

    getTotalWeightSelected() {
      let weight = 0;
      this.form.service_orders.map((service) => {
        weight += service.weight;
      });
      return parseFloat(weight.toFixed(3));
    },
  },
  methods: {
    async getTravelOrderById() {
      this.form.travel_date = moment().format("DD/MM/YYYY");
      if (this.travelId == null) return;
      try {
        const { data } = await TravelOrdersService.getTravelOrderById({
          id: this.travelId,
        });
        this.form.serie = data.serie;
        this.form.number = data.number;
        this.form.travel_date = moment(data.travel_date).format("DD/MM/YYYY");
        this.form.modality = data.modality;
        this.form.vehicle_id = data.vehicle_id;
        this.form.driver_id = data.driver_id;
        this.form.trailer_id = data.trailer_id;
        this.form.service_orders = data.service_orders;

        if (data.toll_group_id) {
          this.form.origin = data.origin;
          this.form.destination = data.destination;
          this.form.count_tolls = data.count_tolls;
          this.form.tolls = data.tolls;
        } else {
          if (data.service_orders.length) this.setTolls(data.service_orders);
        }
        await this.getDataVehicleSelected();
      } catch (error) {
        throw error;
      }
    },

    setTolls(service_orders = []) {
      let indexx = null;
      let maxLength = 0;
      service_orders.map((service, index) => {
        const tolls = service.tolls == null ? [] : service.tolls;
        if (tolls.length > 0 && tolls.length > maxLength) {
          indexx = index;
          maxLength = tolls.length;
        }
      });
      if (indexx != null) {
        this.form.tolls = service_orders[indexx].tolls;
        this.form.count_tolls = maxLength;
        if (this.form.tolls.length) {
          this.form.origin = this.form.tolls[0].origin;
          this.form.destination = this.form.tolls[0].destination;
        }
      }
    },

    async registerTravel() {
      const result = await this.$refs["ref-validation-travel"].validate();
      if (!result) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;

      try {
        this.addPreloader();

        const params = {
          travel_date: this.form.travel_date,
          modality: this.form.modality,
          driver_id: this.form.driver_id,
          vehicle_id: this.form.vehicle_id,
          trailer_id: this.form.trailer_id,
          services: JSON.stringify(this.form.service_orders),
        };

        const { data } = await TravelOrdersService.registerTravelOrder(params);
        if (data.type == "success") {
          this.showToastSuccess(data.message);
          this.$emit("refreshTable");
        } else {
          this.showToastWarning(data.message);
        }
      } catch (error) {
        console.log(error?.response);
        this.showToastError(error?.response?.data);
      } finally {
        this.removePreloader();
      }
    },

    async editTravel() {
      // console.log("orders:",this.form.service_orders);
      const result = await this.$refs["ref-validation-travel"].validate();
      if (!result) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;

      try {
        this.addPreloader();
        const services = this.form.service_orders.filter((s) => !s.is_delete);
        const params = {
          travel_id: this.travelId,
          travel_date: this.form.travel_date,
          modality: this.form.modality,
          driver_id: this.form.driver_id,
          vehicle_id: this.form.vehicle_id,
          trailer_id: this.form.trailer_id,
          services: JSON.stringify(services),
        };

        const { data } = await TravelOrdersService.editTravelOrder(params);
        if (data.type == "success") {
          this.showToastSuccess(data.message);
          this.$emit("refreshTable");
        } else {
          this.showToastWarning(data.message);
        }
      } catch (error) {
        console.log(error);
        console.log(error?.response?.data?.message ?? error?.response);
        this.showToastError(error?.response?.data?.message ?? error?.response);
      } finally {
        this.removePreloader();
      }
    },

    async getDriversForSelect() {
      try {
        const { data } = await EmployeeService.getEmployeesByType({
          type: "Driver",
        });
        this.driverOptions = data;
      } catch (error) {
        console.log(error);
      }
    },

    async getVehiclesForSelect(type) {
      try {
        const { data } = await vehiclesService.getVehiclesForSelect({ type });
        if (type == "vehicle") this.vehicleOptions = data;
        if (type == "trailer") this.trailerOptions = data;
      } catch (error) {
        console.log(error);
      }
    },

    addServices(services) {
      services.map((service) => {
        const isExist = this.form.service_orders.find(
          (serv) => serv.service_id == service.service_id
        );

        if (!isExist) this.form.service_orders.push(service);
      });
      this.addServicesModal = false;
    },

    addServiceOrders() {
      const currentServices = this.form.service_orders.map((service) => {
        return service.service_id;
      });
      this.currentServices = currentServices;
      this.addServicesModal = true;
    },

    closeSidebar(action) {
      this.$emit("hideSidebar", action);
    },

    deleteService(service) {
      if (service.travel_id != null) {
        this.$set(service, "is_delete", true);
      } else {
        const filter = this.form.service_orders.filter(
          (so) => so.service_id != service.service_id
        );
        this.form.service_orders = filter;
      }
    },

    async getDataVehicleSelected() {
      this.addPreloader();
      try {
        const { data } = await vehiclesService.getVehicleInfoForTravel({
          vehicle_id: this.form.vehicle_id,
        });
        this.vehicleInfo.current_km = data.current_km;
        this.vehicleInfo.load_capacity_type = data.load_capacity_type;
        this.vehicleInfo.load_capacity = data.load_capacity;
        this.vehicleInfo.axies_number = data.axies_number;
        this.vehicleInfo.dry_weight = data.dry_weight;
        this.vehicleInfo.gross_weight = data.gross_weight;
        this.vehicleInfo.useful_load = data.useful_load;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    positionDropdown(dropdownList, component, { width, top, left }) {
      dropdownList.style.zIndex = 9999;
      dropdownList.style.maxHeight = "20rem";
      dropdownList.style.top = top;
      dropdownList.style.left = left;
      dropdownList.style.width = width;
    },
  },
};
</script>

<style>
.sticky-data {
  position: sticky;
  bottom: 0;
  z-index: 1000;
}
</style>